import styles from './styles.module.scss';
import { FC } from 'react';

interface LoaderInterface {
  title?: string;
}

const Loader: FC<LoaderInterface> = ({ title }) => {
  return (
    <div className={styles['Loader']}>
      <div className={styles['loader-content']}>
        <div className={styles['loader-icon']}></div>
        {title && <div className={styles['loading-text']}>{title} ...</div>}
      </div>
      <div className={styles['blur']}></div>
    </div>
  );
};

export { Loader };
